$(document).ready(function() {

    // SIMULATEUR DE PRIX (DEVIS)

    // Tableau des tarifs
    var Prices = {
        '-18':{ 'formuleI':16.56,'formuleG':22.56},
        '18':{ 'formuleI':16.56,'formuleG':22.56},
        '19':{ 'formuleI':16.72,'formuleG':23.42},
        '20':{ 'formuleI':16.88,'formuleG':24.31},
        '21':{ 'formuleI':17.04,'formuleG':25.24},
        '22':{ 'formuleI':17.21,'formuleG':26.20},
        '23':{ 'formuleI':17.38,'formuleG':26.83},
        '24':{ 'formuleI':18.17,'formuleG':27.48},
        '25':{ 'formuleI':19.00,'formuleG':28.13},
        '26':{ 'formuleI':19.88,'formuleG':28.81},
        '27':{ 'formuleI':20.78,'formuleG':29.49},
        '28':{ 'formuleI':21.73,'formuleG':30.21},
        '29':{ 'formuleI':22.73,'formuleG':30.93},
        '30':{ 'formuleI':23.78,'formuleG':31.67},
        '31':{ 'formuleI':24.86,'formuleG':32.43},
        '32':{ 'formuleI':26.01,'formuleG':33.21},
        '33':{ 'formuleI':27.21,'formuleG':33.99},
        '34':{ 'formuleI':27.83,'formuleG':34.80},
        '35':{ 'formuleI':28.45,'formuleG':35.63},
        '36':{ 'formuleI':29.10,'formuleG':36.47},
        '37':{ 'formuleI':29.77,'formuleG':37.33},
        '38':{ 'formuleI':30.44,'formuleG':38.21},
        '39':{ 'formuleI':31.13,'formuleG':39.12},
        '40':{ 'formuleI':31.83,'formuleG':40.05},
        '41':{ 'formuleI':32.55,'formuleG':41.00},
        '42':{ 'formuleI':33.29,'formuleG':41.97},
        '43':{ 'formuleI':34.33,'formuleG':42.98},
        '44':{ 'formuleI':35.40,'formuleG':44.00},
        '45':{ 'formuleI':36.51,'formuleG':45.04},
        '46':{ 'formuleI':37.65,'formuleG':46.11},
        '47':{ 'formuleI':38.83,'formuleG':47.20},
        '48':{ 'formuleI':39.50,'formuleG':48.32},
        '49':{ 'formuleI':40.18,'formuleG':49.46},
        '50':{ 'formuleI':40.88,'formuleG':50.63},
        '51':{ 'formuleI':41.58,'formuleG':51.83},
        '52':{ 'formuleI':42.30,'formuleG':53.08},
        '53':{ 'formuleI':43.31,'formuleG':54.35},
        '54':{ 'formuleI':44.34,'formuleG':55.64},
        '55':{ 'formuleI':45.40,'formuleG':56.96},
        '56':{ 'formuleI':46.49,'formuleG':58.32},
        '57':{ 'formuleI':47.61,'formuleG':59.71},
        '58':{ 'formuleI':48.88,'formuleG':61.13},
        '59':{ 'formuleI':50.19,'formuleG':62.58},
        '60':{ 'formuleI':51.54,'formuleG':64.07},
        '61':{ 'formuleI':52.92,'formuleG':65.60},
        '62':{ 'formuleI':54.34,'formuleG':67.16},
        '63':{ 'formuleI':55.77,'formuleG':68.76},
        '64':{ 'formuleI':57.24,'formuleG':70.40},
        '65':{ 'formuleI':58.75,'formuleG':72.08},
        '66':{ 'formuleI':60.30,'formuleG':73.79},
        '67':{ 'formuleI':61.89,'formuleG':75.54},
        '68':{ 'formuleI':63.69,'formuleG':77.35},
        '69':{ 'formuleI':65.55,'formuleG':79.20},
        '70':{ 'formuleI':67.46,'formuleG':81.08},
        '71':{ 'formuleI':69.43,'formuleG':83.02},
        '72':{ 'formuleI':69.43,'formuleG':84.99},
        '73':{ 'formuleI':69.43,'formuleG':86.78},
        '74':{ 'formuleI':69.43,'formuleG':88.59},
        '75':{ 'formuleI':69.43,'formuleG':90.45},
        '76':{ 'formuleI':69.43,'formuleG':92.34},
        '77':{ 'formuleI':69.43,'formuleG':93.21},
        '+77':{ 'formuleI':69.43,'formuleG':93.21}
    };


    // Formulaire 1 : Check l'age en temps réel (< à 18 ans)

    $( "#formAge" ).change(function() {
        var date = $('#formAge').val();
        var age = calculateAge(date);

        if(age < 18) {
            $(".section-header .part-left form .error").fadeIn().css("display","block");;
            $("#formAge").addClass("error-input");
        } else {
            $(".section-header .part-left form .error").fadeOut();
            $("#formAge").removeClass("error-input");
        }
    });


    // Formulaire 1 : clique

    $( "#ctaCalculezTarif" ).click(function() {

        // On récupère l'age et la formule
        var date = $('#formAge').val();
        var age = calculateAge(date);
        var formule = $('#formFormule').val();

        if(formule == "formuleI") {
            textFormule = "Initiale";
        } else {
            textFormule = "Globale";
        }

        if(age !="" && !isNaN(age)) {  // Si l'age n'est pas vide
            if(age < 18) { // Si inférieur à 18, on affiche un message d'erreur
                $(".section-header .part-left form .error").fadeIn().css("display","block");
                $("#formAge").addClass("error-input");
            } else if(age > 77) { // Si supérieur à 77 on force la ligne du tableau à prendre
                openStep2(); // On lance le JS pour afficher l'étape suivante qui affiche le prix
                $(".form-step-3 .text-result .result").text(Prices["+77"][formule].toFixed(2)+" €");
            } else { // Sinon entre 18 et 77 ans compris
                openStep2();
                $(".form-step-3 .text-result .result").text(Prices[age][formule].toFixed(2)+" €");
            }

            // Script qui lance le loader et affiche le prix
            function openStep2() {
                $(".form-step-1").hide(); // On masque le premier formulaire
                $(".form-step-2").fadeIn(); // Correspond au loader
                $(".form-step-3 .text-formule .formule").text(textFormule);

                $(".inputAge input").val(age + " ans"); // Met dans des champs cachés du formulaire d'envoi
                $(".inputFormule input").val("Formule "+textFormule);  // Met dans des champs cachés du formulaire d'envoi

                setTimeout(function() {
                    $(".form-step-2").hide();
                    $(".form-step-3").fadeIn();
                    $(".section-header").addClass("active");
                    $('html,body').animate({scrollTop: 0}, 'slow');

                    // DataLayer - pageView Tarif
                    window.dataLayer.push({
                        'event': 'pageviewCustomEvent',
                        'pagePath': '/tarif',
                        'pageTitle': 'Tarif'
                    });
                }, 2000);
            }
        }
    });

    // Formulaire 2 : code postal / departement
    var $postcodeField = $(".form-postcode input");
    var $departementSelector = $(".form-departement select");
    var $departementOptions = $(".form-departement option");
    $postcodeField.change(function() {
        var postcode = $(this).val();

        if (postcode.length === 5) {
            var firstNum = postcode.charAt(0);
            var departement = postcode.slice(0, 2);

            // Corse
            if (firstNum === '2') {
                if (parseInt(postcode) >= 20000 && parseInt(postcode) < 20200) {
                    departement = '2A';
                } else if (parseInt(postcode) >= 20200 && parseInt(postcode) < 21000) {
                    departement = '2B';
                }
            }

            // Outre mer
            if (departement === '97') {
                departement = postcode.slice(0, 3);
            }

            var findDepartement = false;
            $departementOptions.each(function(){
                var optionText = $(this).text();
                if(optionText.startsWith(departement)){
                    $(this).prop('selected', true);
                    findDepartement = true;
                }
            });

            if (!findDepartement) {
                $departementSelector.prop('selectedIndex', 0);
                $postcodeField.val('');
            }
        } else {
            $departementSelector.prop('selectedIndex', 0);
        }
    });


    function calculateAge(dateString) {
        var today = new Date();
        var birthDate = new Date(dateString);
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    }

    // DataLayer - pageView Form OK
    $(document).on('frmFormComplete', function(event, form, response) {
        window.dataLayer.push({
            'event': 'pageviewCustomEvent',
            'pagePath': '/fin_ok',
            'pageTitle': 'finOk'
        });
    });

    // DataLayer - pageView Form KO
    $(document).on('frmFormErrors', function(event, form, response){
        console.log('error');
        window.dataLayer.push({
            'event': 'pageviewCustomEvent',
            'pagePath': '/fin_ko',
            'pageTitle': 'finKO'
        });
    });

    // POPIN
    $(".bloc-tel").on("click", function() {
        $(".section-popin, .mask").addClass("active").fadeIn();
    });
    $(".mask").on("click", function() {
        $(".section-popin, .mask").removeClass("active").fadeOut();
    });

    // SCROLL TOP CLICK
    $('a[href^="#"]').on('click',function (e) {
        e.preventDefault();
        var target = this.hash,
            $target = $(target);
        $('html, body').stop().animate({
            'scrollTop': $target.offset().top
        }, 900, 'swing', function () {
            window.location.hash = target;
        });
    });
});
